import { ReactivationCampaignType } from 'src/services/reactivation.types';

export interface ReactivationCampaignDisplay {
  pageTitle: string;
  badgeLabel: string;
  ctaLabel: string;
  showFreeTrial: boolean;
}

const DEFAULT_DISPLAY: ReactivationCampaignDisplay = {
  pageTitle: 'Your fresh start awaits',
  badgeLabel: '',
  ctaLabel: 'Reactivate subscription',
  showFreeTrial: false,
};

export const getCampaignDisplay = (
  campaignType: ReactivationCampaignType | null | undefined,
  discountPercent?: number | null
): ReactivationCampaignDisplay => {
  switch (campaignType) {
    case ReactivationCampaignType.FREE_MONTH:
      return {
        pageTitle: 'Claim your free month!',
        badgeLabel: '1 Month Free',
        ctaLabel: 'Start my free month',
        showFreeTrial: true,
      };
    case ReactivationCampaignType.DISCOUNT_ROLLOVER: {
      // Only show the percentage when we have a valid number from the BE.
      const hasDiscount = discountPercent != null && !isNaN(discountPercent);
      return {
        pageTitle: hasDiscount
          ? `Don't lose your ${discountPercent}% discount!`
          : "Don't lose your discount!",
        badgeLabel: hasDiscount ? `${discountPercent}% Discount Rollover` : '',
        ctaLabel: 'Reactivate with my discount',
        showFreeTrial: false,
      };
    }
    default:
      return DEFAULT_DISPLAY;
  }
};
